




















import Vue from 'vue'

import Popper from '../../utility-bar/Popper.vue'

import ProjectSelect from './ProjectSelect.vue'

export default Vue.extend({
    components: {
        Popper,
        ProjectSelect
    },
    props: {
        projectLabel: {type: String}
    },
    data: () => ({
        open: false
    }),
    methods: {
        close() {
            this.open = false
        },
        handleClick() {
            this.open = !this.open
        },
        handleSelect(project: any) {
            this.$emit('project:selected', project)
        },
        handleSelectAll() {
            this.$emit('project:select-all')
        }
    }
})
